import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/report-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-e33bd54a")

_pushScopeId("data-v-e33bd54a")
const _hoisted_1 = { class: "grid grid-cols-2 gap-4 search-popup py-4" }
const _hoisted_2 = { class: "flex flex-row py-4" }
const _hoisted_3 = { class: "flex flex-row py-4" }
const _hoisted_4 = { class: "w-full py-2" }
const _hoisted_5 = { class: "py-2" }
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = { class: "py-2" }
const _hoisted_11 = { class: "flex flex-row py-4" }
const _hoisted_12 = {
  key: 0,
  style: {"margin-top":"0.15rem"}
}
const _hoisted_13 = { class: "flex text-green-lp-100 mt-3" }
const _hoisted_14 = { class: "pl-1" }
const _hoisted_15 = { class: "text-red-lp-300 mt-1" }
const _hoisted_16 = { class: "py-2" }
const _hoisted_17 = {
  key: 2,
  class: "text-red-lp-100 text-12px xxl:text-14px pl-1 py-2 flex gap-x-2"
}
const _hoisted_18 = { class: "flex text-green-lp-100 mt-3" }
const _hoisted_19 = { class: "pl-1" }
const _hoisted_20 = { class: "text-red-lp-300 mt-1" }
const _hoisted_21 = {
  class: "px-4 py-3 flex flex-row items-center rounded-lg w-full",
  style: {"background-color":"#f5f5f5","box-shadow":"0px 1px 4px 0px rgba(26, 20, 33, 0.15)"}
}
const _hoisted_22 = { class: "text-14px font-normal font-montserrat text-gray-lp-300" }
const _hoisted_23 = {
  key: 0,
  class: "border-t border-gray-lp-400 px-8"
}
const _hoisted_24 = {
  key: 1,
  class: "text-14 text-gray-lp-600 space-y-6 py-6"
}
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "flex flex-row justify-between items-center" }
const _hoisted_27 = { class: "space-x-2 flex flex-row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-12",
  alt: "report-red"
}, null, -1)
const _hoisted_29 = { class: "flex flex-col" }
const _hoisted_30 = { class: "text-16 text-black-lp-300 font-semibold" }
const _hoisted_31 = { class: "text-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ModalForm = _resolveComponent("ModalForm")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_ModalForm, {
        key: 0,
        title: _ctx.data.title,
        onClose: _ctx.onClose,
        modalWidth: "w-1/2",
        isFooter: false,
        stylesContent: "px-0",
        isScroll: false
      }, {
        content: _withId(() => [
          _createVNode("div", _hoisted_1, [
            (_ctx.isPosParentOptions)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: _ctx.$t('report.cards.colPartnerName')
                }, {
                  default: _withId(() => [
                    (_ctx.isShowPosParentDefault)
                      ? (_openBlock(), _createBlock(_component_LpInput, {
                          key: 0,
                          modelValue: _ctx.dataProfile.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataProfile.name = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_SelectSearch, {
                          key: 1,
                          options: _ctx.posParentOrBranch,
                          onFocus: _ctx.onSearchPosParent,
                          onFilter: _ctx.onSearchPosParent,
                          keyName: "name",
                          keyValue: "id",
                          placeholder: _ctx.$t('report.modal.placeholderPosParent'),
                          modelValue: _ctx.posParentOrBranchSelected,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.posParentOrBranchSelected = $event)),
                          isLoading: _ctx.isLoadingPosParentOrBranch,
                          class: "my-2"
                        }, null, 8, ["options", "onFocus", "onFilter", "placeholder", "modelValue", "isLoading"]))
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.showDataTypes)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  label: _ctx.$t('report.cards.reportTypeData')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_2, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTypes, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "w-1/2 p-field-radiobutton gap-x-3 flex flex-row lp-radio"
                        }, [
                          _createVNode(_component_RadioButton, {
                            id: `radio-${item.value}`,
                            name: "report-type",
                            value: item.value,
                            modelValue: _ctx.dataType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataType = $event)),
                            onChange: _ctx.onGetListDownloadReport
                          }, null, 8, ["id", "value", "modelValue", "onChange"]),
                          _createVNode("label", {
                            for: `radio-${item.value}`
                          }, _toDisplayString(item.name), 9, ["for"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isShowReportType)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  label: _ctx.$t('report.cards.reportType')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_3, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportTypeList, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "w-1/2 p-field-radiobutton gap-x-3 flex flex-row lp-radio"
                        }, [
                          _createVNode(_component_RadioButton, {
                            id: `radio-${item.value}`,
                            name: "report-type",
                            value: item.value,
                            modelValue: _ctx.reportType,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.reportType = $event)),
                            disabled: _ctx.isReportTypeDisabled && _ctx.reportType !== item.value
                          }, null, 8, ["id", "value", "modelValue", "disabled"]),
                          _createVNode("label", {
                            for: `radio-${item.value}`
                          }, _toDisplayString(item.name), 9, ["for"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isShowBookedFor)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 3,
                  label: _ctx.$t('report.modal.sttBookedFor')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_4, [
                      _createVNode(_component_Select, {
                        value: _ctx.bookedFor,
                        dataSelect: _ctx.bookedForList,
                        onOpenSelect: _ctx.onOpenSelectBookedFor,
                        onCloseSelect: _ctx.onCloseSelectBookedFor,
                        onChooseSelect: _ctx.onSelectBookedFor,
                        class: "w-full",
                        isOpenMenu: _ctx.openSelectBookedFor,
                        longTrim: 17,
                        isDisabled: _ctx.isAccountDataEntry
                      }, null, 8, ["value", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu", "isDisabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isShowClientPartner)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 4,
                  label: `${_ctx.clientPartnerTitle}`,
                  asterisk: ""
                }, {
                  default: _withId(() => [
                    (!_ctx.isShowClientPartnerDefault)
                      ? (_openBlock(), _createBlock(_component_SelectSearch, {
                          key: 0,
                          isDisabled: _ctx.isClientNameDisabled,
                          placeholder: _ctx.clientPartnerPlaceholder,
                          modelValue: _ctx.clientNameDisplay,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.clientNameDisplay = $event)),
                          options: _ctx.clientNameList,
                          onFocus: _ctx.onSearchClientName,
                          onFilter: _ctx.onSearchClientName,
                          keyName: "name",
                          keyValue: "id",
                          isLoading: _ctx.isLoadingPartnerClient,
                          class: "my-2",
                          style: {"width":"100%"}
                        }, null, 8, ["isDisabled", "placeholder", "modelValue", "options", "onFocus", "onFilter", "isLoading"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isShowPartner)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 5,
                  label: `${_ctx.clientPartnerTitle}`
                }, {
                  default: _withId(() => [
                    (_ctx.isShowClientPartnerDefault)
                      ? (_openBlock(), _createBlock(_component_LpInput, {
                          key: 0,
                          modelValue: _ctx.dataProfile.name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataProfile.name = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]))
                      : (_ctx.isShowPosParent)
                        ? (_openBlock(), _createBlock(_component_SelectSearch, {
                            key: 1,
                            options: _ctx.posParentOrBranch,
                            onFilter: _ctx.onSearchPosBranch,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: _ctx.$t('report.modal.placeholderPosBranch'),
                            modelValue: _ctx.posParentOrBranchSelected,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.posParentOrBranchSelected = $event)),
                            isLoading: _ctx.isLoadingPosParentOrBranch,
                            class: "my-2"
                          }, null, 8, ["options", "onFilter", "placeholder", "modelValue", "isLoading"]))
                        : (_openBlock(), _createBlock(_component_SelectSearch, {
                            key: 2,
                            placeholder: _ctx.$t('report.modal.placeholderSelect'),
                            modelValue: _ctx.partnerNameDisplay,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.partnerNameDisplay = $event)),
                            options: _ctx.partnerNameList,
                            onFocus: _ctx.onSearchPartnerName,
                            onFilter: _ctx.onSearchPartnerName,
                            keyName: "name",
                            keyValue: "id",
                            isLoading: _ctx.isLoadingPartner,
                            class: "my-2",
                            style: {"width":"100%"}
                          }, null, 8, ["placeholder", "modelValue", "options", "onFocus", "onFilter", "isLoading"]))
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.data.description === 'Misroute')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 6,
                  label: _ctx.$t('report.modal.misrouteType')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_Select, {
                        value: _ctx.misrouteValue,
                        dataSelect: _ctx.misrouteData,
                        onOpenSelect: _ctx.onOpenMisrouteSelect,
                        onCloseSelect: _ctx.onCloseMisrouteSelect,
                        onChooseSelect: _ctx.onSelectMisroute,
                        class: "w-full",
                        isOpenMenu: _ctx.misrouteSelect,
                        longTrim: 17
                      }, null, 8, ["value", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.data.description === 'Scrap')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 7,
                  label: _ctx.$t('report.modal.scrapType')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode(_component_Select, {
                        value: _ctx.scrapValue,
                        dataSelect: _ctx.scrapData,
                        onOpenSelect: _ctx.onOpenScrapSelect,
                        onCloseSelect: _ctx.onCloseScrapSelect,
                        onChooseSelect: _ctx.onSelectScrap,
                        class: "w-full",
                        isOpenMenu: _ctx.scrapSelect,
                        longTrim: 17
                      }, null, 8, ["value", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.data.description === 'Shortland')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 8,
                  label: _ctx.$t('report.modal.shortlandType')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_Select, {
                        value: _ctx.shortlandValue,
                        dataSelect: _ctx.shortlandData,
                        onOpenSelect: _ctx.onOpenshortlandSelect,
                        onCloseSelect: _ctx.onCloseshortlandSelect,
                        onChooseSelect: _ctx.onSelectshortland,
                        class: "w-full",
                        isOpenMenu: _ctx.shortlandSelect,
                        longTrim: 17
                      }, null, 8, ["value", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.data.description === 'Pembatalan STT')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 9,
                  label: _ctx.$t('report.modal.cancelBased')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_8, [
                      _createVNode(_component_Select, {
                        value: _ctx.cancelValue,
                        dataSelect: _ctx.cancelData,
                        onOpenSelect: _ctx.onOpenCancelSelect,
                        onCloseSelect: _ctx.onCloseCancelSelect,
                        onChooseSelect: _ctx.onSelectCancel,
                        class: "w-full",
                        isOpenMenu: _ctx.cancelSelect,
                        longTrim: 17
                      }, null, 8, ["value", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isShowOriginCity)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 10,
                  label: _ctx.$t('report.cards.colCity')
                }, {
                  default: _withId(() => [
                    (_ctx.isShowOriginDefault)
                      ? (_openBlock(), _createBlock(_component_LpInput, {
                          key: 0,
                          modelValue: _ctx.originCity,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.originCity = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_SelectSearch, {
                          key: 1,
                          placeholder: _ctx.$t('report.modal.placeholderCity'),
                          modelValue: _ctx.cityDisplay,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.cityDisplay = $event)),
                          options: _ctx.cityList,
                          onFocus: _ctx.onSearchCity,
                          onFilter: _ctx.onSearchCity,
                          keyName: "name",
                          keyValue: "code",
                          isLoading: _ctx.isLoadingCity,
                          class: "my-2",
                          style: {"width":"100%"},
                          isDisabled: _ctx.isAccountDataEntry
                        }, null, 8, ["placeholder", "modelValue", "options", "onFocus", "onFilter", "isLoading", "isDisabled"]))
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isInternal)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 11,
                  label: _ctx.$t('report.cards.sttBookedBy')
                }, {
                  default: _withId(() => [
                    _createVNode(_component_SelectSearch, {
                      placeholder: _ctx.$t('report.modal.placeholderAccount'),
                      modelValue: _ctx.sttBookedByValue,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.sttBookedByValue = $event)),
                      options: _ctx.sttBookedByList,
                      onFocus: _ctx.onSearchBookedBy,
                      onFilter: _ctx.onSearchBookedBy,
                      keyName: "name",
                      keyValue: "code",
                      isLoading: _ctx.isLoadingCity,
                      class: "my-2",
                      style: {"width":"100%"},
                      isDisabled: _ctx.isDisabledSttBookedBy || _ctx.isAccountDataEntry
                    }, null, 8, ["placeholder", "modelValue", "options", "onFocus", "onFilter", "isLoading", "isDisabled"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.data.description === 'STT Manual')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 12,
                  label: _ctx.$t('report.modal.sttStatus')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_Select, {
                        value: _ctx.sttStatusValue,
                        dataSelect: _ctx.sttStatusData,
                        onOpenSelect: _ctx.onOpenSttStatusSelect,
                        onCloseSelect: _ctx.onCloseSttStatusSelect,
                        onChooseSelect: _ctx.onSelectSttStatus,
                        class: "w-full",
                        isOpenMenu: _ctx.sttStatusSelect,
                        longTrim: 17
                      }, null, 8, ["value", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.data.description === 'Top Up')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 13,
                  label: _ctx.$t('report.modal.topUpType')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_Select, {
                        value: _ctx.topupTypeValue,
                        dataSelect: _ctx.topupTypeData,
                        onOpenSelect: _ctx.onOpenTopupTypeSelect,
                        onCloseSelect: _ctx.onCloseTopupTypeSelect,
                        onChooseSelect: _ctx.onSelectTopupType,
                        class: "w-full",
                        isOpenMenu: _ctx.topupTypeSelect,
                        longTrim: 17
                      }, null, 8, ["value", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "isOpenMenu"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isDeliveryBy)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 14,
                  label: _ctx.$t('report.modal.deliveryBy')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryByOptions, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "w-1/3 p-field-radiobutton gap-x-3 flex flex-row lp-radio"
                        }, [
                          _createVNode(_component_RadioButton, {
                            id: `delivery-by-radio-${item.value}`,
                            name: "delivery-by-radio",
                            value: item.value,
                            modelValue: _ctx.deliveryBy,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.deliveryBy = $event)),
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.partnerNameDisplay = ''))
                          }, null, 8, ["id", "value", "modelValue"]),
                          _createVNode("label", {
                            for: `delivery-by-radio-${item.value}`
                          }, _toDisplayString(item.name), 9, ["for"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isFetchPartner)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 15,
                  label: _ctx.$t('report.cards.colPartnerName')
                }, {
                  default: _withId(() => [
                    (!_ctx.isInternal)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          _createVNode(_component_LpInput, {
                            modelValue: _ctx.dataProfile.account_type_detail.company_name,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dataProfile.account_type_detail.company_name = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]))
                      : (_openBlock(), _createBlock(_component_SelectSearch, {
                          key: 1,
                          placeholder: 
              `${_ctx.$t(
                'report.modal.placeholderSelect'
              )} ${_ctx.deliveryByNameSelected}`
            ,
                          modelValue: _ctx.partnerNameDisplay,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.partnerNameDisplay = $event)),
                          options: _ctx.fetchPartnerOptions,
                          onFocus: _ctx.fetchPartner,
                          onFilter: _ctx.filterFetchPartner,
                          keyName: "name",
                          keyValue: "id",
                          isLoading: _ctx.isLoadingFetchPartner,
                          class: "my-2"
                        }, null, 8, ["placeholder", "modelValue", "options", "onFocus", "onFilter", "isLoading"]))
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.data.description === 'STT' && !_ctx.isInternal)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 16,
                  label: _ctx.$t('report.cards.labelLastSyncData')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_Icons, {
                        name: "cycle-time",
                        width: "14px"
                      }),
                      _createVNode("p", _hoisted_14, _toDisplayString(_ctx.loadingSyncSttManual ? `${_ctx.$t("Loading")}...` : _ctx.lastSyncSttManual), 1)
                    ]),
                    _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("report.cards.descLastSyncData")), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('report.cards.colDate')
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_16, [
                  (_ctx.isUsingDateRange)
                    ? (_openBlock(), _createBlock(_component_TimeRangePicker, {
                        key: 0,
                        style: {"width":"100%"},
                        onSelect: _ctx.setPeriode,
                        default: _ctx.defaultDateRange,
                        showOptions: _ctx.rangeOptions(),
                        customTotalMaxDate: _ctx.rangeLimit,
                        maxDate: _ctx.maxRangeDatePicker,
                        onDayClick: _ctx.setDay,
                        isOptionDisabled: !_ctx.isStartDate,
                        onCancelRangePick: _ctx.cancelRangePick,
                        onValidateSelectPerMonth: _ctx.validateSelectPerMonth
                      }, null, 8, ["onSelect", "default", "showOptions", "customTotalMaxDate", "maxDate", "onDayClick", "isOptionDisabled", "onCancelRangePick", "onValidateSelectPerMonth"]))
                    : (_openBlock(), _createBlock(_component_DatePicker, {
                        key: 1,
                        modelValue: _ctx.startDate,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.startDate = $event)),
                        "max-date": new Date(),
                        class: "w-full mb-1 picker"
                      }, null, 8, ["modelValue", "max-date"])),
                  (
                _ctx.isErrorDateSelectedPerMonth &&
                  _ctx.data.description === 'Bonus Komisi'
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.$t("report.modal.dateRangeErrorStart")) + " " + _toDisplayString(_ctx.$t("report.modal.dateRangeErrorChange")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.data.description === 'STT' && _ctx.isInternal)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 17,
                  label: _ctx.$t('report.cards.labelLastSyncData')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_Icons, {
                        name: "cycle-time",
                        width: "14px"
                      }),
                      _createVNode("p", _hoisted_19, _toDisplayString(_ctx.loadingSyncSttManual ? `${_ctx.$t("Loading")}...` : _ctx.lastSyncSttManual), 1)
                    ]),
                    _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("report.cards.descLastSyncData")), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", {
            class: 
          `flex ${
            _ctx.isOnProgressFetchDataReport || _ctx.isProcessing
              ? 'flex-row gap-x-5 justify-center'
              : 'justify-end'
          } items-center pb-6 mt-5`
        
          }, [
            _withDirectives(_createVNode("div", _hoisted_21, [
              _createVNode(_component_Icons, {
                width: "24",
                height: "24",
                class: "mr-2",
                name: "warning-circle",
                color: "#C64D51"
              }),
              _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("report.cards.waitingDownload")), 1)
            ], 512), [
              [_vShow, _ctx.isOnProgressFetchDataReport || _ctx.isProcessing]
            ]),
            _createVNode(_component_LpButton, {
              onClick: _cache[17] || (_cache[17] = () => _ctx.onDownloadCsv(true)),
              customClass: "px-10 py-2",
              textColor: "white",
              title: _ctx.$t('Cari'),
              disabled: _ctx.isDisabled || _ctx.isOnProgressFetchDataReport || _ctx.isProcessing
            }, null, 8, ["title", "disabled"])
          ], 2),
          _createVNode(_Transition, { name: "download" }, {
            default: _withId(() => [
              (_ctx.isSearch)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    (_ctx.isError)
                      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                          key: 0,
                          errorImage: "data-not-found",
                          errorTitle: _ctx.$t('report.modal.dataNotFound'),
                          errorMessage: _ctx.$t('report.modal.dataNotFoundMessage')
                        }, null, 8, ["errorTitle", "errorMessage"]))
                      : (_openBlock(), _createBlock("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("report.modal.showingReportSearch")), 1),
                          _createVNode("div", _hoisted_26, [
                            _createVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createVNode("div", _hoisted_29, [
                                _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("report.modal.reportDescription")) + " " + _toDisplayString(_ctx.data.displayLabel || _ctx.data.description), 1),
                                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.converDate), 1)
                              ])
                            ]),
                            _createVNode("div", null, [
                              _createVNode(_component_LpButton, {
                                onClick: _cache[18] || (_cache[18] = () => _ctx.onDownloadCsv(false)),
                                customClass: "px-2 py-2",
                                textColor: "white",
                                iconLeft: "document-download-outline-white",
                                title: _ctx.$t('report.modal.download')
                              }, null, 8, ["title"])
                            ])
                          ])
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "onClose"]))
    : _createCommentVNode("", true)
})